import moment from 'moment';
import { ProjectHelper } from 'src/app/core';

import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';

@Component({
  selector: 'shared-filter-panel-date-range',
  templateUrl: './filter-panel-date-range.component.html',
  styleUrls: ['./filter-panel-date-range.component.scss'],
  host: { class: 'shared-filter-panel-month-range' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelDateRangeComponent implements OnInit {
  @Input() dateRange: Filter[] = [];
  @Output() dateRangeChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(private projectHelper: ProjectHelper) {}

  from?: moment.Moment;
  to?: moment.Moment;

  ngOnInit() {
    if (this.dateRange?.length > 0) {
      const dateRangeArray = this.dateRange[0]?.value.split(',').map((s: any) => new Date(s.trim()));
      this.from = moment(dateRangeArray[0]);
      this.to = moment(dateRangeArray[1]);
    }
  }

  toChange(range: any) {
    const toDate = moment(range);

    if (!this.from) {
      this.from = moment(toDate).utc().subtract(1, 'months');
    }
    if (toDate && toDate.toDate() < this.from.toDate()) {
      this.from = moment(toDate).utc().subtract(1, 'months');
    }

    const fromDate = moment(this.from);

    this.dateRange = [
      <Filter>{
        value: `${fromDate?.format('DD MMM YYYY')},${toDate?.format('DD MMM YYYY')}`,
        displayName:
          'Date Range - From ' +
          moment(fromDate).format('DD MMM YYYY') +
          ' - To ' +
          moment(toDate).format('DD MMM YYYY'),
        type: 'dateRange',
      },
    ];
  }

  fromChange(range: any) {
    const fromDate = moment(range);

    if (!this.to) {
      this.to = moment(fromDate).utc().add(1, 'months');
    }
    if (fromDate && this.to.toDate() < fromDate.toDate()) {
      this.to = moment(fromDate).utc().add(1, 'months');
    }

    const toDate = moment(this.to);
    this.dateRange = [
      <Filter>{
        value: `${fromDate?.format('DD MMM YYYY')},${toDate?.format('DD MMM YYYY')}`,
        displayName:
          'Date Range - From ' +
          moment(fromDate).format('DD MMM YYYY') +
          ' - To ' +
          moment(toDate).format('DD MMM YYYY'),
        type: 'dateRange',
      },
    ];
  }

  clear() {
    this.dateRange = [];
    this.dateRangeChange.emit(this.dateRange);
  }

  closeFilterPanel() {
    this.dateRangeChange.emit(this.dateRange);
    this.close.emit();
  }

  isValid(): boolean {
    if (!this.dateRange || this.dateRange.length === 0) {
      return false;
    }

    const fromDate = this.projectHelper.convertTimeOfDay(this.from as moment.Moment, 'start')?.toDate();
    const toDate = this.projectHelper.convertTimeOfDay(this.to as moment.Moment, 'end')?.toDate();

    if (!fromDate || !toDate || fromDate >= toDate) {
      return false;
    }

    return true;
  }
}
